import React, { Component } from 'react'

export default class ClientLogoGrid extends Component {
  render() {
    const { component } = this.props

    return (
      <section
        className={`grid-component client-logo-grid margin-${
          component.marginBelow
        }`}
      >
        <div className="grid-row">
          {component.clientReferences &&
            component.clientReferences.map((item, i) => {
              return (
                <div
                  className="image-container"
                  key={`image_${i}-${item.title}`}
                >
                  <a href={item.linkUrl} target="_blank">
                    <img
                      src={`${item.logo.file.url}?w=160&h=160&fit=fill`}
                      alt={item.title}
                    />
                  </a>
                </div>
              )
            })}
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/shared-page-components/client-logo-grid.js